import * as React from 'react';
import {Tooltip} from '@mui/material';
import {Button} from '@material-ui/core';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ContactSave from './ContactSave';
import DeleteAlert from '../components/DeleteAlert';
import Alert from '../components/Alert';
import {API_URL} from '../utils/EnvVars';
import axios from 'axios';
import {Edit} from '@mui/icons-material';


export default function BasicTable(props) {
  const childRefSave = React.useRef();
  const childRefAlert = React.useRef();  
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [alertMessage, setAlertMessage] = React.useState("");

  const [rows, setRows] = React.useState([]);
  const [dataObj, setDataObj] = React.useState({});

  React.useEffect(() => {
    setRows(props.rows);
  }, [props.rows]);

  function add() { 
      setDataObj({});
      childRefSave.current.handleClickOpen();
  }

  function edit(obj) { 
      setDataObj(obj);
      childRefSave.current.handleClickOpen();
  }

  function updatedList(list){
      setRows(list);
      props.contactsUpdatedList(list);
  }


	function deleteNow(obj){
		if(obj && obj!=null && props.userObj){
			let apiUrl=API_URL+'/crm-delete-contacts';
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': props.userObj.registerId,
					'uid': props.userObj.loginId,
					'fullName': props.userObj.fullName,
					'token': props.userObj.token,
				}
			};
  
		  const data = new FormData();
		  data.append('id', obj.autoId);				 
      data.append('accountId', obj.accountId);

		  axios.post(apiUrl, data, axiosHeader)
				.then((response) => {
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");					
					setAlertMessage("Contact has been deleted.");
          childRefAlert.current.handleClickOpen();
          setRows(response.data.list);
					return false;
				}else{
			  	setSeverityAlert("error");
					setAlertMessage("Contact could not be deleted.");		
          childRefAlert.current.handleClickOpen();	
					return false;
				}
			})
			.catch((error) => {
          setSeverityAlert("error");
					setAlertMessage(" "+error);		
          childRefAlert.current.handleClickOpen();	
					return false;
			})	
		}		
	
		
	}


  return (<>
    <div style={{textAlign:'center',marginBottom:10}}>
      {(props.privileges && props.privileges.indexOf("create")>-1)?
          <Button onClick={() => {add()}} style={{textTransform:'none',maxHeight:25}} size="small" variant="outlined" >New Contact</Button>
      :null}
    </div>
    <TableContainer component={Paper}>
      <Table sx={{ width: '100%' }} aria-label="simple table">
        <TableHead>
          <TableRow>             
            <TableCell>Contact Name</TableCell> 
            <TableCell>Mobile</TableCell>
            <TableCell>Phone</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Address</TableCell> 
            <TableCell>City</TableCell>         
            <TableCell style={{textAlign:'center'}}>                    
            </TableCell> 
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?rows.map((row) => (
            <TableRow
              key={row.autoId}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">{row.contactName}</TableCell> 
              <TableCell>
                {(row.mobile && row.mobile.length>5)?<>
                  <a href={'https://wa.me/'+row.mobile+'?text=Hello'} style={{textDecoration:'none'}} target='_blank' >
                    <i className="fa fa-whatsapp whatsAppBtnColor"></i> {row.mobile}
                  </a>
                </>:null}
              </TableCell>
              <TableCell>{row.phone}</TableCell>
              <TableCell>{row.email}</TableCell>
              <TableCell>{row.address}</TableCell>
              <TableCell>{row.city}</TableCell>
              <TableCell style={{textAlign:'center'}} >
                {(props.privileges && props.privileges.indexOf("update")>-1)?
                  <Tooltip title={'Edit, Last Modified By: '+row.lastModifiedAlias+', '+row.lastModifiedDateTime} arrow>
                      <Edit className='iconGraySmall' onClick={()=>{edit(row)}}  />
                  </Tooltip>
                :null}
                {(props.privileges && props.privileges.indexOf("delete")>-1)?
                  <DeleteAlert deleteNow={deleteNow} dataObj={row} text={'Are you sure, You want to delete contact.'} className='iconGraySmall' />
                :null}
              </TableCell>
            </TableRow>
          )):null}
        </TableBody>
      </Table>
    </TableContainer>
    
    {(!rows || rows.length<1)?<div className='nrfbox'>No contacts found</div>:null}  

		<ContactSave dataObj={dataObj} userObj={props.userObj} accountObj={props.accountObj} updatedList={updatedList} fullList={false} ref={childRefSave} />

    <Alert severityAlert={severityAlert} alertMessage={alertMessage} ref={childRefAlert} />          

  </>);
}
